import React from 'react';

import { faSparkles } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type NeoLeoPromptProps = {
  prompt: string;
  onSelect(): void;
  disabled?: boolean;
};

const NeoLeoPrompt: React.FC<NeoLeoPromptProps> = ({
  prompt,
  onSelect,
  disabled,
}) => (
  <div
    className='m-1 py-1.5 pl-2 pr-4 bg-white bg-opacity-10 text-white hover:text-reskin-aqua rounded-full flex items-center gap-1 ring-[0.5px] hover:ring-1 ring-reskin-aqua cursor-pointer disabled:cursor-not-allowed disabled:opacity-50'
    onClick={() => (!disabled ? onSelect() : null)}
  >
    <FontAwesomeIcon icon={faSparkles} className='text-reskin-aqua mr-1' />
    <p className='font-inter font-light text-sm'>{prompt}</p>
  </div>
);

export default NeoLeoPrompt;
